import { Outlet } from "react-router";
import { CareNav } from "../ui/navigation/CareNav/CareNav";
import { CareWrap } from "../ui/wrappers/CareWrap/CareWrap";

export const CareLayout = () => {
  return (
    <CareWrap>
      <CareNav />
      <Outlet />
    </CareWrap>
  );
};
